export default __webpack_public_path__ + "static/media/organic.ef4fb6e1.svg";